import { useMutation, useQueryClient } from '@tanstack/react-query'

import { LogoutService } from '@/features/user/services'
import { userKeys } from '@/features/user/utils'

export const useLogout = () => {
  const queryClient = useQueryClient()
  const mutation = useMutation({
    mutationKey: userKeys.logout(),
    mutationFn: async () => new LogoutService().execute(),
    onSuccess: () => {
      localStorage.clear()
      queryClient.clear()
    },
  })
  return mutation
}
